import React from "react";
import SupplierContact from "../../components/contact/SupplierContact";

const SupplierContactPage = () => {
	return (
		<>
			<SupplierContact />
		</>
	);
};

export default SupplierContactPage;
